import { useAccessRequests } from "PFCore/hooks/queries/admin/access_requests/use_access_requests";
import { useState } from "react";

export const useAccessRequestPage = () => {
  const [page, setPage] = useState(1);
  const {
    data: accessRequests,
    isInitialLoading,
    isFetching,
    error
  } = useAccessRequests({ page, perPage: 10 }, { keepPreviousData: true });

  return { accessRequests, isInitialLoading, isFetching, error, setPage };
};
